/**
 * Rounds a % Complete / % Requested for display. Whole numbers everywhere, except between 99.5%
 * and 100%: a plain round would print 100% for a job that isn't finished, so that band keeps one
 * decimal and is capped at 99.9% — 100% only ever prints for values of at least 100.0%.
 */
export const roundCompletionPercent = (value: number): number => {
  if (value >= 99.5 && value < 100) return Math.min(Math.round(value * 10) / 10, 99.9);
  return Math.round(value);
};
